import React from "react";
import Button from "./SurveyButton";

const SurveyPagination = ({ pagination, onPage, loading }) => {
  if (!pagination.total) return null;
  return (
    <div className="survey-engine-pagination">
      <span>Showing {pagination.from}–{pagination.to} of {pagination.total}</span>
      <div className="survey-engine-pager">
        <Button icon="fa-chevron-left" disabled={loading || pagination.currentPage <= 1} onClick={() => onPage(pagination.currentPage - 1)}>Previous</Button>
        <strong>Page {pagination.currentPage} of {pagination.lastPage}</strong>
        <Button icon="fa-chevron-right" disabled={loading || pagination.currentPage >= pagination.lastPage} onClick={() => onPage(pagination.currentPage + 1)}>Next</Button>
      </div>
    </div>
  );
};

export default SurveyPagination;
